import {
  AutoComplete,
  ListPlaceholder,
  PaginationScroller,
  SearchBar,
  SelectLabel
} from '@components/common';
import css from './index.module.scss';
import { IconNode, ToolTip } from '@components/base';
import Images from '@assets/images';
import { IQuoteListingState, PaginationNavigator } from '../..';
import EnquiryCard from '../enquiry-card';
import { useSearchParams } from 'react-router-dom';
import { MARKET_TYPE_OPTIONS } from '@helpers/constants';
import SkeletonQuoteListing from '../skeleton';

const EnquiryListing = (props: any) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    quoteState,
    setQuoteState,
    handleOrderSearch,
    filterCreatedBy,
    fetchEnquiryList,
    handleQuoteFormClick,
    validatePageChange,
    itemLimit = 10
  } = props;
  const {
    isLoading,
    isSearchLoading,
    user_list,
    currentPageNumber,
    enquiryCount,
    enquiryList,
    market_type,
    searchText,
    created_by
  } = quoteState;

  const handleMarketTypeChange = (value: any) => {
    setQuoteState((prevState: IQuoteListingState) => ({
      ...prevState,
      market_type: value
    }));
  };

  const handleUserSelection = (event: any, param: any) => {
    if (param?.user_id !== created_by?.user_id) {
      setQuoteState((prevState: IQuoteListingState) => ({
        ...prevState,
        created_by: param
      }));
    }
  };

  return (
    <div className={css.mainWrapper}>
      <section className={css.enquiryFilters}>
        <div className={css.enquiryFiltersWrapper}>
          <div className={css.searchBar}>
            <SearchBar
              isLoading={isSearchLoading}
              placeholder="Search"
              value={searchText}
              className={css.search}
              onChange={handleOrderSearch}
            />
            <ToolTip
              title={'Search By: Customer Name, Product Name, Enquiry Id, Deal Name'}
              placement="right"
            >
              <div>
                <IconNode src={Images.alertGrey} alt="eye icon" />
              </div>
            </ToolTip>
          </div>
          <div className={css.userSelectWrapper}>
            <AutoComplete
              isClearable
              options={user_list}
              value={created_by}
              onInputChange={(event: any, param: string) => {
                if (event && event.type === 'change') {
                  filterCreatedBy(event, param);
                }
              }}
              onInputSelection={handleUserSelection}
              labelKeys={['given_name', 'family_name']}
              getOptionValue={(option: any) => option.user_id}
              placeholder="Search User"
              width="270px"
            />
          </div>
          <div className={css.marketTypeWrapper}>
            <SelectLabel
              options={MARKET_TYPE_OPTIONS}
              placeholder="Market Type"
              value={market_type}
              isClearable
              onChange={handleMarketTypeChange}
              rootClassName={css.selectLabel}
              dropdownDirection={'bottom'}
            />
          </div>
        </div>
        <div className={css.paginationWrapper}>
          <PaginationNavigator
            currentPageNumber={currentPageNumber}
            count={enquiryCount}
            itemLimit={itemLimit}
            validatePageChange={validatePageChange}
          />
        </div>
      </section>

      <section className={css.enquiryList}>
        {isLoading ? (
          <SkeletonQuoteListing />
        ) : enquiryCount > 0 ? (
          enquiryList.map((enquiry: any) => (
            <EnquiryCard
              key={enquiry.enquiry_id}
              data={enquiry}
              fetchEnquiryList={fetchEnquiryList}
            />
          ))
        ) : (
          <ListPlaceholder
            handleButtonClick={() => {
              setSearchParams({
                ...Object.fromEntries(searchParams),
                showQuoteForm: 'true'
              });
              handleQuoteFormClick();
            }}
            title="No Enquiry Added Yet"
            supportingText="When an Enquiry is added by you, they will show up here"
            buttonText="Add Enquiry"
          />
        )}
      </section>

      {!isLoading && (
        <PaginationScroller
          variant="text"
          defaultPage={1}
          count={enquiryCount}
          pageLimit={itemLimit}
          page={currentPageNumber}
          onChange={validatePageChange}
        />
      )}
    </div>
  );
};

export default EnquiryListing;
